import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccSessionTopicSurveyResponse } from '@interfaces';
import { DomainDataService } from '../../../../../../services';
import { DeliveryAreaService } from '../../../../delivery-area.service';
import { DeliveryOverviewService } from '../../../delivery-overview.service';
import { getSetup } from './grid/get-setup';

export interface TopicFeedback extends AccSessionTopicSurveyResponse {
	accId: number,
	accName: string,
	entrepreneurPersonId: number,
	entrepreneurName: string,
	eventId: number,
	eventStartUTC: number,
	topicName: string,
}

@Component({
	selector: 'delivery-topic-feedback-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './topic-feedback-view.part.html',
})
export class DeliveryTopicFeedbackViewPart {

	private readonly util = inject(UtilityService);
	private readonly pageService = inject(DeliveryOverviewService);
	private readonly areaService = inject(DeliveryAreaService);
	private readonly domain = inject(DomainDataService);

	public setup = computed(() => getSetup(this.util, this.areaService));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public topicFeedbacks = computed<TopicFeedback[]>(() => {
		const data = this.areaService.deliveryData();
		if (!data) return [];

		const eventById = this.util.array.toMap(data.events, e => e.eventId);
		const accById = this.util.array.toMap(data.accelerators, acc => acc.accId);
		const entByPersonId = this.util.array.toMap(data.allVentures.flatMap(v => v.entrepreneurs), ent => ent.personId);

		const topicFeedbacks: TopicFeedback[] = [];

		data.accSurveysResponses.forEach(survey => {

			const event = eventById[survey.eventId]!;
			const acc = accById[survey.accId]!;
			const ent = entByPersonId[survey.entrepreneurPersonId]!;

			survey.topicSurveyResponses.forEach(topicSurvey => {
				topicFeedbacks.push({
					...topicSurvey,
					accId: survey.accId,
					accName: acc.name,
					entrepreneurPersonId: survey.entrepreneurPersonId,
					entrepreneurName: ent.name,
					eventId: survey.eventId,
					eventStartUTC: event.startUTC,
					topicName: this.domain.data().topicsMap[topicSurvey.topicId]?.name ?? '',
				});
			});
		});

		return topicFeedbacks;

	});
}